<template>
  <footer class="footer">
    <div class="footer_top">
      <div class="top_start">
        <span>
          One-click installation, very easy to quickly start and run!
        </span>
        <div class="top_trial">
          <!-- <A-Button text="Free trial" @onclick="goLink(`/home`)"></A-Button> -->
          <A-Button text="Free trial"  @onclick="goLink(`https://apps.shopify.com/salesdish`)"></A-Button>
        </div>
      </div>
      <div class="top_us">
        <div class="top_us_left">
          <img src='../../assets/footer_salesdish.svg'
            @click="()=>(this.$route.path=='/home' ? goTop() : goRouter('/home'))" />
        </div>
        <div class="top_us_right">
          <div class="top_content">
            <!-- <div class="top_content_box clearfix">
              <img src="../../assets/footer_address.svg" class="top_content_icon" />
              <div class="top_content_text">Unit A1 of Unit A,11th Floor,Success Commercial Building,<br>
               245-251 Hennessy Road HongKong 999077 China</div>
            </div> -->
            <div class="top_content_box clearfix">
              <img src="../../assets/footer_email.svg" class="top_content_icon" />
              <div class="top_content_text top_content_text_show">support@dropshipnyc.com</div>
            </div>
          </div>
        </div>
      </div>
      <div class="top_bottom">
        <div class="footer_bottom_link">
          <span class="footer_bottom_link_text footer_bottom_link_gang"
            @click="()=>(this.$route.path=='/allapps' ? goTop() : goRouter('/allapps'))">All Apps</span>
          <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goRouter('/article?p=448')">Privacy Policy</span>
          <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goRouter('/help')">Help Center</span>
          <!-- <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goRouter('/home')">Free trial</span> -->
          <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goLink(`https://apps.shopify.com/salesdish`)">Free Trial</span>
          <span class="footer_bottom_link_text" @click="goRouter('/article?p=446')">Merchant Terms of Service</span>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="footer_bottom_box">
        <div class="footer_bottom_record bottom_text">© 2020 SALESDISH All Rights Reserved.</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      inputData: '',
      source: localStorage.getItem('ant_source') || ''
    }
  },
  methods: {
    goRouter (router, id) {
      console.log(router,id)
      let query
      if (id) {
        query = { p: id }
      }
      this.$router.push({
        path: router,
        query
      }).catch(err => {
        console.log('e', err)
      })
    },
    goLink (url) {
      window.open(url)
    },
    goTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  background: #32354D;
}
.footer_top {
  width: 1200px;
  margin: 0 auto;
}
.top_start {
  padding-top: 97px;
  display: flex;
  justify-content: space-between;
  
}
.top_start > span {
  font-size: 28px;
  font-family: Helvetica-Medium, Helvetica;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 33px;
}
.top_trial {
  font-size: 0;
}

.top_us {
  padding-top: 77px;
  display: flex;
  /* align-items: center; */
/* justify-content: space-between; */
}
.top_us_left > img {
  cursor: pointer;
  margin-bottom: 103px;
}


.top_content {
  margin: 0 0 12px 377px;
}
.top_content_box {
  margin-top: 20px;
}
.top_content_icon {
  float: left;
  margin-top: 5px;
}
.top_content_icon3{
  margin-top: 0;
}
.top_content_text {
  float: left;
  margin-left: 25px;
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 28px;
}
.footer_bottom {
  background: rgba(0,0,0,.1);
  filter: blur(0px);
}
.footer_bottom_box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.footer_bottom_link {
  margin-bottom: 48px;
}
.footer_bottom_link_text {
  font-size: 20px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;  
  position: relative;
  cursor: pointer;
}
.footer_bottom_link_text:hover,
.footer_bottom_link_text:focus,
.footer_bottom_link_text:active {
  color: #01C4C7;
}
.footer_bottom_link_text + .footer_bottom_link_text {
  margin-left: 82px;
}
.footer_bottom_link_gang:after {
  content: "";
  width: 1px;
  height: 16px;
  background: #ffffff;
  position: absolute;
  right: -40px;
  top: 3px;
}
.footer_bottom_record {
  font-size: 16px;
  font-family: Helvetica-Regular, Helvetica;
  font-weight: 400;
  color: #8D919B;
  line-height: 19px;
}
.bottom_text {
  margin: 25px 0 25px 0;
}

.clearfix:before,.clearfix:after { 
  content:"";
  display:table; 
}
.clearfix:after {
  clear:both;
}
.clearfix {
  *zoom:1;
}

@media (max-width: 767px) {
  .footer_top {
    width: 100%;
    margin: 0 auto;
    padding:.8rem .48rem .52rem;
  }
  .top_start {
    padding: 0;
    display: block;
  }
  .top_start > span {
    font-size: .32rem;
    font-family: Helvetica-Bold;
    font-weight: 700;
    line-height: .42rem;
  }
  .ad_button{
    background: #01C4C7;
    box-shadow: 0px .09rem .12rem 0px rgba(1,196,199,0.1);
    border-radius: .08rem;
    width: 100%;
    height: .96rem;
    margin: .48rem auto .88rem;
    font-family: Helvetica-Bold;
    font-size: .28rem;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: .96rem;
    font-weight: 700;
    text-align: center;
    padding: 0;
  }
  .top_us {
    padding-top: 0;
    display: block;
  }
  .top_us_left > img {
    width: 2.74rem;
    height: .76rem;
    margin-bottom: .48rem;
  }
  .top_content{
    margin: 0;
  }
  .top_content_box {
    margin-top: 0;
    display: flex;
    align-items: center;
    margin-bottom:.67rem ;
  }
  .top_content_icon {
    float: none;
    margin-top: 0;
    width: .24rem;
    height: .24rem;
  }
  .top_content_icon3{
    margin-top: 0;
  }
  .footer_bottom{
    background: rgba(0,0,0,.1);
    opacity: 1;
  }
  .top_content_text {
    margin-left: .08rem;
    font-size: .24rem;
    line-height: initial;
  }
  .footer_bottom_box {
    width: 100%;
    height: .72rem;
  }
  .footer_bottom_link {
    margin-bottom: 0;
    display: flex;
    flex-wrap: wrap;
  }
  .footer_bottom_link_text {
    /* width: 50%; */
    opacity: 0.6;
    font-family: Helvetica;
    font-size: .2rem;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 400;
    line-height: initial;  
    margin-bottom: .28rem;
  }
  .footer_bottom_link_text:hover,
  .footer_bottom_link_text:focus,
  .footer_bottom_link_text:active {
    color: #01C4C7;
  }
  .footer_bottom_link_text + .footer_bottom_link_text {
    margin-left: 0;
  }
  .footer_bottom_link_text:nth-child(odd){
    width: 60%;
  }
   .footer_bottom_link_text:nth-child(even){
    width: 40%;
  }
  .footer_bottom_link_gang:after {
    display: none;
  }
  .footer_bottom_record {
    font-size: .18rem;
    font-family: Helvetica-Regular, Helvetica;
    font-weight: 400;
    color: #8D919B;
    line-height: .72rem;
  }
  .bottom_text {
    margin:0;
  }

  .clearfix:before,.clearfix:after { 
    content:"";
    display:table; 
  }
  .clearfix:after {
    clear:both;
  }
  .clearfix {
    *zoom:1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue